var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49 49",
    style: {
      enableBackground: "new 0 0 49 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#193B57;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,19.2l-0.1-0.1l-1.7-1.7c1.4-0.3,3-1.5,3-2.7c0-1.4-2-1.9-3.7-1.9c-1.8,0-2,1.2-2,2.1L37,10.6 C36.1,9.7,34.4,9,33.1,9h-8.6l0,0h-8.6c-1.3,0-3,0.7-3.9,1.6l-4.4,4.3c0-0.9-0.2-2.1-2-2.1c-1.7,0-3.7,0.5-3.7,1.9 c0,1.2,1.5,2.4,3,2.7l-1.7,1.7l-0.1,0.1c-1.8,1.6-3,4.5-3,6.6v6.3C0,33.6,0.6,35,1.6,36v2.4c0,1.4,1.2,2.6,2.7,2.6h3.2 c1.5,0,2.7-1.2,2.7-2.6v-0.6h14.4l0,0H39v0.6c0,1.4,1.2,2.6,2.7,2.6h3.2c1.5,0,2.7-1.2,2.7-2.6V36c1-1,1.6-2.4,1.6-3.9v-6.3 C49,23.7,47.8,20.8,46,19.2z M13.6,12.4c0.6-0.5,1.7-0.9,2.3-0.9h8.6l0,0h8.6c0.5,0,1.6,0.4,2.3,0.9l5.8,5.6H24.5l0,0H7.8 L13.6,12.4z M2,24.8C2,23.3,3.2,22,4.7,22s6.4,2.9,6.4,4.4s-4.9,1.2-6.4,1.2S2,26.4,2,24.8z M10.1,35.1H9.6H9.1H6 c-0.8-0.3-1.4-0.6-1.9-0.9c-0.2-0.2-0.4-0.3-0.5-0.5s-0.2-0.3-0.3-0.5c-0.4-1.1,0.4-2.1,0.4-2.1H9l3.5,4H10.1L10.1,35.1z M32,35.1 h-7.5l0,0H17c-1.6,0-2.8-1.3-2.8-2.8h10.3l0,0h10.3C34.8,33.8,33.6,35.1,32,35.1z M32.7,30.3h-8.2l0,0h-8.2c-1.7,0-3.1-2.1-3.1-4.7 h11.2l0,0h11.2C35.7,28.2,34.4,30.3,32.7,30.3z M45.6,33.1c-0.1,0.2-0.2,0.3-0.3,0.5s-0.3,0.3-0.5,0.5c-0.4,0.3-1,0.6-1.9,0.9h-3.1 h-0.5h-0.5h-2.4l3.5-4h5.2C45.2,31.1,46,32.1,45.6,33.1z M44.3,27.6c-1.5,0-6.4,0.4-6.4-1.2s4.9-4.4,6.4-4.4s2.7,1.3,2.7,2.8 C47,26.4,45.8,27.6,44.3,27.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.5aa9ab48c815687b4bac6937d323bd4b.svg";
export { ForwardRef as ReactComponent };